module.exports = __webpack_public_path__ + "img/en.b398ba42.svg";